import { cn } from './chunk-FFX3LZW7.js';
import * as React from 'react';
import { jsx } from 'react/jsx-runtime';

var Card = React.forwardRef(
  function Card2({ className, ...props }, ref) {
    return /* @__PURE__ */ jsx(
      "div",
      {
        ref,
        className: cn(
          "rounded-lg border bg-card text-card-foreground shadow-sm",
          className
        ),
        ...props
      }
    );
  }
);
var CardHeader = React.forwardRef(
  function CardHeader2({ className, ...props }, ref) {
    return /* @__PURE__ */ jsx("div", { ref, className: cn("flex flex-col space-y-1.5 p-6", className), ...props });
  }
);
var CardTitle = React.forwardRef(
  function CardTitle2({ className, ...props }, ref) {
    return /* @__PURE__ */ jsx(
      "h3",
      {
        ref,
        className: cn("text-lg font-semibold leading-none tracking-tight", className),
        ...props
      }
    );
  }
);
var CardDescription = React.forwardRef(function CardDescription2({ className, ...props }, ref) {
  return /* @__PURE__ */ jsx("p", { ref, className: cn("text-sm text-muted-foreground", className), ...props });
});
var CardContent = React.forwardRef(
  function CardContent2({ className, ...props }, ref) {
    return /* @__PURE__ */ jsx("div", { ref, className: cn("p-6 pt-0", className), ...props });
  }
);
var CardFooter = React.forwardRef(
  function CardFooter2({ className, ...props }, ref) {
    return /* @__PURE__ */ jsx("div", { ref, className: cn("flex items-center p-6 pt-0", className), ...props });
  }
);

export { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle };
//# sourceMappingURL=chunk-WNZ465SZ.js.map
//# sourceMappingURL=chunk-WNZ465SZ.js.map